export default __webpack_public_path__ + "static/media/dane.7a415250.jpg";